import { IJackpotDisplay } from "./IJackpotDisplay";
import { JackpotDisplayCaliente } from "./JackpotDisplayCaliente";
import { JackpotDisplayDiamodPotPlayCity } from "./JackpotDisplayDiamodPotPlayCity";
import { JackpotDisplayDiamondPot } from "./JackpotDisplayDiamondPot";
import { JackpotDisplayDiamondPotStep } from "./JackpotDisplayDiamondPotStep";
import { JackpotDisplayJubilee } from "./JackpotDisplayJubilee";
import { JackpotDisplayJubileeLink } from "./JackpotDisplayJubileeLink";
import { JackpotDisplayJubileeLinkResponsive } from "./JackpotDisplayJubileeLinkResponsive";
import { JackpotDisplayOrtiz } from "./JackpotDisplayOrtiz";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { JackpotDisplayPaytable } from "./JackpotDisplayPaytable";
import { JackpotDisplayPlayCityLink } from "./JackpotDisplayPlayCityLink";
import { JackpotDisplayPlayCityLinkResponsive } from "./JackpotDisplayPlayCityLinkResponsive";
import { JackpotDisplayPrecSpin } from "./JackpotDisplayPrecSpin";
import { JackpotDisplayPyramid } from "./JackpotDisplayPyramid";
import { JackpotDisplayRapidLinkDiamondPotFire } from "./JackpotDisplayRapidLinkDiamondPotFire";
import { JackpotDisplayRapidLinkDiamondPotStep } from "./JackpotDisplayRapidLinkDiamondPotStep";
import { JackpotDisplayRappidDiamondPot } from "./JackpotDisplayRappidDiamondPot";
import { JackpotDisplayViventoLink2S } from "./JackpotDisplayViventoLink2";
import { JackpotDisplayType } from "../Settings";

interface JackpotDisplayProperties {
    readonly alias: JackpotDisplayType | null;
}
type JackpotDisplayMap = Readonly<Record<JackpotDisplayType, JackpotDisplayProperties>>;

export const JackpotDisplayProperties: JackpotDisplayMap = {
    [JackpotDisplayType.DiamondPot]: { alias: null },
    [JackpotDisplayType.DiamondPotOrtiz]: { alias: null },
    [JackpotDisplayType.DragonJackpot]: { alias: null },
    [JackpotDisplayType.PreciousSpin]: { alias: null },
    [JackpotDisplayType.DiamondPotStep]: { alias: null },
    [JackpotDisplayType.DiamondPotJubilee]: { alias: null },
    [JackpotDisplayType.DiamondPotCaliente]: { alias: null },
    [JackpotDisplayType.DiamondPotPlayCity]: { alias: null },
    [JackpotDisplayType.PlayCityLink]: { alias: null },
    [JackpotDisplayType.PlayCityLinkResponsive]: { alias: JackpotDisplayType.PlayCityLink },
    [JackpotDisplayType.JubileeLink]: { alias: null },
    [JackpotDisplayType.JubileeLinkResponsive]: { alias: JackpotDisplayType.JubileeLink },
    [JackpotDisplayType.ViventoLink]: { alias: null },
    [JackpotDisplayType.PaytableJackpotDisplay]: { alias: null },
    [JackpotDisplayType.RapidDiamondPot]: { alias: null },
    [JackpotDisplayType.RapidDiamondPotStep]: { alias: null },
    [JackpotDisplayType.RapidDiamondPotFire]: { alias: null },
    [JackpotDisplayType.DiamondPotResponsive]: { alias: JackpotDisplayType.DiamondPot },
    [JackpotDisplayType.RapidDiamondPot2]: undefined,
    [JackpotDisplayType.DiamondPotRappidFrames]: undefined,
    [JackpotDisplayType.DiamondPotStepRappidFrames]: undefined,
    [JackpotDisplayType.RapidDiamondPotStep2]: undefined,
    [JackpotDisplayType.RainbowGirls]: undefined,
    [JackpotDisplayType.DiamondPotStepShared]: undefined,
    [JackpotDisplayType.DiamondPotStepSinShared]: undefined,
    [JackpotDisplayType.DiamondPotStepRappidFramesSpine]: undefined,
    [JackpotDisplayType.DiamondPotRappidFramesSpine]: undefined,
    [JackpotDisplayType.DiamondPotResponsivePIXI]: { alias: JackpotDisplayType.DiamondPot },
    [JackpotDisplayType.PlayCityLinkResponsivePIXI]: { alias: JackpotDisplayType.PlayCityLink },
    [JackpotDisplayType.JubileeLinkResponsivePIXI]: { alias: JackpotDisplayType.JubileeLink },
    [JackpotDisplayType.DiamondPotStepSharedSpineV2]: undefined,
    [JackpotDisplayType.DiamondPotStepSinSharedSpineV2]: undefined,
    [JackpotDisplayType.DiamondPotPyramidShared]: undefined,
    [JackpotDisplayType.DiamondPotPyramidSinShared]: undefined,
    [JackpotDisplayType.DiamondPotPyramidJP4ShareJP3SinShared]: undefined,
    [JackpotDisplayType.DiamondPotPyramidShared2S]: undefined,
    [JackpotDisplayType.DiamondPotPyramidSinShared2S]: undefined,
    [JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S]: undefined,
    [JackpotDisplayType.DiamondPotResponsivePIXIHorizontal]: { alias: JackpotDisplayType.DiamondPot },
    [JackpotDisplayType.DiamondPotPyramidSinSharedResponsive]: { alias: JackpotDisplayType.DiamondPotPyramidSinShared },
    [JackpotDisplayType.JubileeLinkResponsivePIXIAPPHorizontal]: { alias: JackpotDisplayType.JubileeLink },
    [JackpotDisplayType.JackpotDisplayPlayCityPIXIAPPHorizontal]: { alias: JackpotDisplayType.PlayCityLink },
    [JackpotDisplayType.JackpotDisplayRapidLinkPIXIAPPHorizontal]: { alias: JackpotDisplayType.RapidDiamondPot },
    [JackpotDisplayType.MysticPortalLinkHorizontal]: { alias: JackpotDisplayType.MysticPortalLink3S },
    [JackpotDisplayType.MysticPortalLink3S]: { alias: JackpotDisplayType.MysticPortalLink3S },
    [JackpotDisplayType.MysticPortalResponsive]: { alias: JackpotDisplayType.MysticPortalLink3S },
};
